import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchEventHeadliners } from '../../api/artistVotes';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

/** { [eventId]: [{ spotifyId, name }, ...] } for a list of events - the feed tiles' play button. */
export function useEventHeadliners(eventIds) {
  const queryClient = useQueryClient();
  const ids = [...new Set(eventIds)].sort();
  return useQuery({
    queryKey: queryKeys.events.headliners(ids),
    queryFn: () => fetchEventHeadliners(ids),
    enabled: ids.length > 0,
    staleTime: STALE.semiStatic,
    // The key is the exact page of ids, and the feed's first refresh after launch changes the page, so nothing cached
    // matched and every play button waited on a fresh fetch. Until it lands, take each event's headliners from any
    // earlier page (persisted across launches) - an event seen before shows its button at once.
    placeholderData: () => {
      const known = {};
      for (const [, data] of queryClient.getQueriesData({
        queryKey: queryKeys.events.headliners([]).slice(0, 3),
      })) {
        if (data) Object.assign(known, data);
      }
      const picked = {};
      for (const id of ids) if (known[id]) picked[id] = known[id];
      return Object.keys(picked).length ? picked : undefined;
    },
  });
}
